export default "__VITE_ASSET__9RTduez9__"